/* src/app/private/components/sales-mail-hub/mail-right-section/mail-right-section.component.scss */
::ng-deep .p-editor-content {
  min-height: 24rem;
}
::ng-deep .p-editor-toolbar {
  border-bottom: 1px solid #e5e7eb;
  background-color: #f9fafb;
}
::ng-deep .p-editor .ql-toolbar {
  border-radius: 0.5rem 0.5rem 0 0;
}
::ng-deep .p-editor .ql-container {
  border-radius: 0 0 0.5rem 0.5rem;
}
.message-container {
  overflow-y: auto;
  scroll-behavior: smooth;
  position: relative;
}
.attachment-remove-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  background-color: #ef4444;
  border: none;
  border-radius: 50%;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transform: scale(0.8);
  transition: all 0.2s ease-in-out;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
  z-index: 10;
}
.attachment-remove-btn:hover {
  background-color: #dc2626;
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);
}
.attachment-remove-btn:active {
  transform: scale(0.95);
}
.attachment-remove-btn i {
  font-size: 10px;
  line-height: 1;
}
.group:hover .attachment-remove-btn {
  opacity: 1;
  transform: scale(1);
}
.attachments-section {
  scroll-margin-top: 20px;
  position: relative;
}
/*# sourceMappingURL=mail-right-section.component.css.map */
